import React from 'react';
import {
  Typography,
  Button,
  TextField,
  InputAdornment,
} from '@material-ui/core';
import { Formik } from 'formik';
import { StyledForm, WideBox, FormRow } from '../../styles/styles';
import { useRootStore } from '../../../stores/BridgeProvider';
import { SplitSchema } from '../../../validation';

const DefaultComm = ({ orgInfo, getOrgInfo }) => {
  const { RentalSplit, SaleSplit } = orgInfo;
  const { authStore } = useRootStore();
  return (
    <Formik
      validationSchema={SplitSchema}
      validateOnChange={false}
      initialValues={{
        rentalSplit: RentalSplit * 100,
        saleSplit: SaleSplit * 100,
      }}
      onSubmit={async (values, actions) => {
        try {
          const { rentalSplit, saleSplit } = values;
          await authStore.request.post(
            `${process.env.REACT_APP_API}/api/organization-split`,
            {
              rentalSplit: rentalSplit / 100,
              saleSplit: saleSplit / 100,
            },
          );
          await getOrgInfo();
          actions.resetForm();
        } catch (e) {
          console.error(e);
          actions.setSubmitting(false);
        }
      }}
      render={({
        handleBlur,
        handleChange,
        errors,
        handleSubmit,
        values,
        isSubmitting,
        dirty,
      }) => {
        return (
          <WideBox style={{ minHeight: 'auto' }}>
            <Typography variant="h4">
              Default Commission Splits for New Agents
            </Typography>
            <StyledForm onSubmit={handleSubmit}>
              <FormRow>
                <TextField
                  name="rentalSplit"
                  label="Rental Split"
                  type="number"
                  value={values.rentalSplit}
                  margin="normal"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  variant="outlined"
                  fullWidth
                  error={errors.rentalSplit}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">%</InputAdornment>
                    ),
                  }}
                />
                <TextField
                  name="saleSplit"
                  label="Sale Split"
                  type="number"
                  value={values.saleSplit}
                  margin="normal"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  variant="outlined"
                  fullWidth
                  error={errors.saleSplit}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">%</InputAdornment>
                    ),
                  }}
                />
              </FormRow>
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <Button
                  color="primary"
                  variant="contained"
                  type="submit"
                  size="large"
                  disabled={!dirty || isSubmitting}
                  style={{
                    margin: '5px',
                    marginRigt: '0px',
                  }}
                >
                  Submit
                </Button>
              </div>
            </StyledForm>
          </WideBox>
        );
      }}
    />
  );
};

export default DefaultComm;
